// Nieuwe adressen (oprichter 28 sep 2026): de app op amumin.app, het bord op board.amumin.app,
// uitleg over de app op app.amumin.com. Bedrijfsgegevens in de app (art. 3:15d BW) en het rustige
// verzoek om meldingen in deze browser weer aan te zetten (een nieuw adres = opnieuw toestemming).
// {app} = "amumin.app", {board} = "board.amumin.app", {kvk} = het KvK-nummer.
export const appDomeinNl = {
    company: {
        title: 'Bedrijfsgegevens',
        kvk: 'KvK {kvk}',
        contact: 'Contact',
        where: 'De app staat op {app} en het bord aan de muur op {board}. Log alleen in op {app}.',
    },
    /** Oude beginscherm-app van f.amumin.com: weg, en {app} opnieuw op het beginscherm. */
    homeScreen: 'Had je AMUMIN op je beginscherm? Verwijder het oude icoon en zet {app} opnieuw op je beginscherm. Op een iPhone of iPad werken meldingen alleen vanaf het beginscherm.',
    push: {
        title: 'Meldingen staan in deze browser uit',
        body: 'AMUMIN staat nu op amumin.app. Meldingen zet je per adres aan, dus in deze browser moet dat nog een keer. Wil je hier weer meldingen krijgen?',
        action: 'Meldingen aanzetten',
        later: 'Niet nu',
        done: 'Meldingen staan weer aan.',
        denied: 'Deze browser blokkeert meldingen. Je kunt ze toestaan in de instellingen van je browser.',
    },
};
//# sourceMappingURL=domeinApp.nl.js.map